/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const getSettingsResponse = zod.object({
  "notifyBy": zod.object({
  "email": zod.boolean(),
  "inbox": zod.boolean(),
  "push": zod.boolean(),
  "sms": zod.boolean(),
  "signalR": zod.boolean()
}),
  "roster": zod.object({
  "filter": zod.object({
  "show1099": zod.boolean(),
  "showW2": zod.boolean(),
  "showUnclassified": zod.boolean(),
  "showPayoutReady": zod.boolean(),
  "showPayoutNotReady": zod.boolean()
})
}),
  "showDevTools": zod.boolean(),
  "onboardingProgressState": zod.enum(['Expanded', 'Collapsed', 'Dismissed'])
})

export const updateSettingsBody = zod.object({
  "notifyBy": zod.object({
  "email": zod.boolean(),
  "push": zod.boolean(),
  "sms": zod.boolean(),
  "signalR": zod.boolean()
}).optional(),
  "roster": zod.object({
  "filter": zod.object({
  "show1099": zod.boolean(),
  "showW2": zod.boolean(),
  "showUnclassified": zod.boolean(),
  "showPayoutReady": zod.boolean(),
  "showPayoutNotReady": zod.boolean()
})
}).optional(),
  "showDevTools": zod.boolean().nullish(),
  "onboardingProgressState": zod.enum(['Expanded', 'Collapsed', 'Dismissed']).optional()
})

export const updateSettingsResponse = zod.object({
  "notifyBy": zod.object({
  "email": zod.boolean(),
  "inbox": zod.boolean(),
  "push": zod.boolean(),
  "sms": zod.boolean(),
  "signalR": zod.boolean()
}),
  "roster": zod.object({
  "filter": zod.object({
  "show1099": zod.boolean(),
  "showW2": zod.boolean(),
  "showUnclassified": zod.boolean(),
  "showPayoutReady": zod.boolean(),
  "showPayoutNotReady": zod.boolean()
})
}),
  "showDevTools": zod.boolean(),
  "onboardingProgressState": zod.enum(['Expanded', 'Collapsed', 'Dismissed'])
})

